module.exports = "<div class=\"in-accordion\" ng-if=\"Ctrl.options.container == 'accordion'\">\n\t<p> <strong>{{ Ctrl.input.label | translate}}</strong> </p>\n\t\n\t<ul>\n\t\t<li ng-repeat=\"item in Ctrl.input.data\"> {{ item.value }} </li>\n\t</ul>\n</div>\n\n<div class=\"in-panel\" ng-if=\"Ctrl.options.container == 'panel'\">\n\t<ul class=\"list-group md-whiteframe-z0 coustom-scroll\">\n\t\t<li class=\"list-group-item\" ng-repeat=\"item in Ctrl.input.data\">\n\n\t\t\t{{ item.value }}\n\n\t\t</li>\n\t</ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/input-form-view/templates/list-view.html
// module id = 309
// module chunks = 0